/**
 * Properties + DAC7 — API service.
 *
 * W2 Priority 5. Wraps the DAC7 summary + PropertyOwner endpoints with a
 * consistent axios setup and JWT auth. Throws axios errors on failure —
 * callers should catch them.
 */
import axios from 'axios'
import { SETTINGS } from '@/config/settings'

const base = `${SETTINGS.API.baseUrl}/api/pms`

function authHeaders() {
  const token = localStorage.getItem('token')
  return token ? { Authorization: `Bearer ${token}` } : {}
}

const client = axios.create({
  timeout: SETTINGS.API.timeout || 30000,
})

client.interceptors.request.use((config) => {
  config.headers = { ...config.headers, ...authHeaders() }
  return config
})

export default {
  list() {
    return client.get(`${base}/properties/`).then((r) => r.data)
  },
  dac7Summary() {
    return client.get(`${base}/properties/dac7-summary/`).then((r) => r.data)
  },
  getOwner(property_id) {
    return client.get(`${base}/property-owner/${property_id}/`).then((r) => r.data)
  },
  saveOwner(property_id, payload, hasFile = false) {
    if (hasFile) {
      const fd = new FormData()
      Object.entries(payload).forEach(([k, v]) => {
        if (v !== null && v !== undefined) fd.append(k, v)
      })
      return client
        .put(`${base}/property-owner/${property_id}/`, fd, {
          headers: { 'Content-Type': 'multipart/form-data' },
        })
        .then((r) => r.data)
    }
    return client.put(`${base}/property-owner/${property_id}/`, payload).then((r) => r.data)
  },
  createOwner(property_id, payload) {
    return client.post(`${base}/property-owner/${property_id}/`, payload).then((r) => r.data)
  },
  getSettings(property_id) {
    return client.get(`${base}/settings/${property_id}/`).then((r) => r.data)
  },
  saveSettings(property_id, payload) {
    return client.post(`${base}/settings/${property_id}/`, payload).then((r) => r.data)
  },
  getDetails(property_id) {
    return client.get(`${base}/property-details/${property_id}/`).then((r) => r.data)
  },
  saveDetails(property_id, payload) {
    return client.put(`${base}/property-details/${property_id}/`, payload).then((r) => r.data)
  },
}
